module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0xMi41IDBDMTkuMTI5IDAgMjQuNSA1LjM3MDk3IDI0LjUgMTJDMjQuNSAxOC42MjkgMTkuMTI5IDI0IDEyLjUgMjRDNS44NzA5NyAyNCAwLjUgMTguNjI5IDAuNSAxMkMwLjUgNS4zNzA5NyA1Ljg3MDk3IDAgMTIuNSAwWiIgZmlsbD0iIzdEMkRGRiIvPgogIDxwYXRoIGQ9Ik02LjUgMTIuNDAxMkwxMC41IDE2LjQwMTJMMTguOSA4LjAwMTIyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/check/check-in-circle_white-with-purple-bg.svg
// module id = sIfz
// module chunks = 35